
import React from 'react';
import CalendarIcon from './icons/CalendarIcon';
import CalendarDaysIcon from './icons/CalendarDaysIcon';
import ChefHatIcon from './icons/ChefHatIcon';
import ListBulletIcon from './icons/ListBulletIcon';
import { getTranslation } from '../utils/translations';
import { Language } from '../types';

interface BottomNavProps {
    activeTab: 'plan' | 'recipes' | 'lists';
    onTabChange: (tab: 'plan' | 'recipes' | 'lists') => void;
    language?: Language;
    isGuidedUser?: boolean;
}

const BottomNav: React.FC<BottomNavProps> = ({ activeTab, onTabChange, language, isGuidedUser = false }) => {
    const t = (key: any) => getTranslation(language, key);

    const tabs = [
        { id: 'recipes' as const, label: t('recipes'), Icon: ChefHatIcon },
        { id: 'plan' as const, label: t('weeklyPlan'), Icon: CalendarIcon },
        { id: 'lists' as const, label: t('shoppingCarts'), Icon: ListBulletIcon },
    ];

    return (
        <nav className="absolute bottom-0 left-0 right-0 bg-white dark:bg-slate-900 border-t border-slate-100 dark:border-slate-800 px-4 pt-3 pb-8 flex justify-between items-center z-40 shadow-[0_-4px_10px_rgba(0,0,0,0.03)] transition-colors duration-200">
            {tabs.map(({ id, label, Icon }) => {
                const isActive = activeTab === id;
                const isLocked = isGuidedUser && id === 'recipes';
                return (
                    <button
                        key={id}
                        id={`bottom-nav-tab-${id}`}
                        onClick={() => {
                            if (isLocked) return;
                            onTabChange(id);
                        }}
                        disabled={isLocked}
                        className={`flex flex-col items-center gap-1 transition-all duration-300 flex-1 relative ${
                            isLocked
                                ? 'text-slate-300 dark:text-slate-600 cursor-not-allowed opacity-70'
                                : isActive
                                    ? 'text-brand-orange scale-105'
                                    : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'
                        }`}
                    >
                        <Icon className={`w-5 h-5 ${isActive && !isLocked ? 'stroke-[2.5px]' : 'stroke-[1.5px]'}`} />
                        <span className={`text-[8px] sm:text-[10px] font-black uppercase tracking-widest ${isActive && !isLocked ? 'opacity-100' : 'opacity-60'}`}>
                            {label}
                        </span>
                        {isLocked && (
                            <span className="absolute -top-1 end-1/4 translate-x-1/2 text-[7px] font-black bg-brand-orange text-white px-1 rounded">
                                {t('proFeature')}
                            </span>
                        )}
                    </button>
                );
            })}
        </nav>
    );
};

export default BottomNav;
